import {userProfile} from '@netx/core-user/collections/singletons/userProfile';

export const getUserLevel = () => userProfile.get('type');

export default getUserLevel;
